export default __webpack_public_path__ + "static/media/kr.6158bd7e.png";